import { addTracksToAutoTaggingChannel } from '@disco/state-management/actions/ExplorerActions'

import React, { useState } from 'react'
import { useDispatch } from 'hooks/use-redux'
import type { Track } from 'types/track'
import Alert from 'components/ui/alert'
import Button from 'components/ui/button'
import Stack from 'components/ui/stack'
import styles from './index.module.css'

type Props = {
  track: Track
  errorMessage?: string
  results?: Track[] | null | undefined
}

const SimilarityAlert = ({
  track,
  errorMessage = undefined,
  results,
}: Props): null | React.ReactElement<'div'> => {
  const dispatch = useDispatch()
  const status = track.similarity_search_status
  const [tagging, setTagging] = useState<{
    submitted: boolean
    error: string | null
  }>({
    submitted: status === 'processing' || status === 'indexed',
    error: null,
  })
  const content: React.ReactElement[] = []

  if (tagging.error || errorMessage) {
    content.push(
      <Alert icon="warning" status="danger">
        {tagging.error || errorMessage}
      </Alert>,
    )
  }

  if (!results && !tagging.error) {
    content.push(
      <Alert status="info">
        {tagging.submitted && (
          <span>
            Track is processing for Similarity Search, you’ll see results here
            soon.
          </span>
        )}
        {!tagging.submitted && (
          <>
            <Button
              compact
              appearance="inline-link"
              caption="Auto-tag it now"
              onClick={async () => {
                const result = await dispatch(
                  addTracksToAutoTaggingChannel([track]),
                )
                setTagging({
                  submitted: true,
                  error: result?.error ? 'Auto-tagging failed' : null,
                })
              }}
            />{' '}
            to see similar tracks.
          </>
        )}
      </Alert>,
    )
  }

  if (!content.length) return null
  return (
    <div className={styles.similarityAlert}>
      <Stack key={track.id} space="xxsmall">
        {content}
      </Stack>
    </div>
  )
}

export default SimilarityAlert
